import { ApiGroup } from '../types/ApiTypes';

export const StepRecordAPI: ApiGroup = {
    pagedList: {
        title: '걸음수 기록 목록 조회',
        method: 'POST',
        url: '/StepRecord/PagedList',
        paramz: {},
    },
};
